import React from 'react';
import Carousel from "react-multi-carousel";
import { useSelector } from 'react-redux';
import { selectDeviceType } from '../../../Redux/selectors';
import { Media } from '../../../helpers/MediaConfig';
import { sliderFrequency } from '../../Context/config';
// ##### Komarov 2025-07-26
import Image from '../PageDevices/CartGallery/Image';

// ##### Komarov 2025-09-02
const AdaptedImage = ({ height, index, image }) => {
  return (
    <div
      key={index}
      data-component="Slide"
      style={{
        width: '100%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <Image
        first={index === 0}
        key={index}
        src={(process.env.REACT_APP_SMART_PROTOCOL || 'https://') + image}
        alt={`Slide ${index}`}
        style={{
          width: '100%',
          objectFit: 'cover',
          height,
        }}
      />
    </div>
  );
};

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 768 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  },
  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
    slidesToSlide: 1 // optional, default to 1.
  }
};

const CarouselSlider = ({ images, className }) => {
  const deviceType = useSelector(selectDeviceType);
  const style = {
    width: '100%',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
  };
  const dataComponent = 'Slide';
  return <Carousel
    arrows
    swipeable={true}
    draggable={true}
    showDots={true}
    responsive={responsive}
    ssr={true} // means to render carousel on server-side.
    infinite={true}
    autoPlay={deviceType !== "mobile" ? true : false}
    autoPlaySpeed={sliderFrequency}
    keyBoardControl={true}
    customTransition="all .5"
    transitionDuration={500}
    containerClass={`carousel-container ${className}`}
    // removeArrowOnDeviceType={["tablet", "mobile"]}
    removeArrowOnDeviceType={["mobile"]}
    deviceType={deviceType}
    dotListClass="custom-dot-list-style"
    itemClass="carousel-item-padding-40-px"
  >
    {
      images.map((image, index) => {
        return (
          <div key={index}>
            <Media
              lessThan="Mobile-L-425-768"
              data-component={dataComponent}
              style={style}
            >
              <AdaptedImage height="37vw" index={index} image={image} />
            </Media>
            <Media
              greaterThanOrEqual="Mobile-L-425-768"
              data-component={dataComponent}
              style={style}
            >
              <AdaptedImage height="27vw" index={index} image={image} />
            </Media>
          </div>
        );
      })
    }
  </Carousel>;
};

export default CarouselSlider;